export default {
	CHECK_CAPTCHA: "checkCaptcha",
	REGISTRATION: "registrationOrAuth",
	SEND_CODE: "",
	SEND_CODE_AGAIN: "",
}
